'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fluxActions = require('flux-actions');

var _ActionTypes = require('MeetingsLib/redux/actions/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = false;

exports.default = (0, _fluxActions.handleActions)(_defineProperty({}, _ActionTypes2.default.USER_PROFILE_FETCH_SUCCEEDED, function (state, action) {
  var isSalesStarter = action.payload.isSalesStarter;

  return isSalesStarter;
}), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/redux/reducers/isSalesStarter.js
// module id = 527
// module chunks = 0